import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { DropHeading } from "./DropHeading";
import { ArticleCard } from "../journal/ArticleCard";
import { ARTICLES } from "../journal/articles";

export const ErthJournalStrip = () => (
  <section id="journal" data-testid="erth-journal-strip" className="bg-erth-white py-20 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 sm:px-8">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-2xl">
          <p className="mb-6 font-body text-sm tracking-[0.25em] text-erth-black/50">journal</p>
          <DropHeading testId="erth-journal-heading" text="guides for planning your escape" className="text-3xl leading-[1.15] text-erth-black sm:text-4xl lg:text-5xl" />
        </div>
        <Link to="/journal" data-testid="erth-journal-all-link" className="inline-flex items-center gap-2 font-head text-[14px] font-semibold lowercase text-erth-black transition-opacity hover:opacity-60">
          all articles <ArrowUpRight size={16} strokeWidth={2} />
        </Link>
      </Reveal>
      <div className="mt-14 grid gap-x-8 gap-y-12 sm:grid-cols-3 lg:mt-20">
        {ARTICLES.slice(0, 3).map((a, i) => (
          <Reveal key={a.slug} delay={i * 0.08}><ArticleCard a={a} index={i + 2} /></Reveal>
        ))}
      </div>
    </div>
  </section>
);
